//플레이딩동 - 본사 - 앱 통계 페이지
import React, { useState, useEffect, useCallback, forwardRef, useImperativeHandle } from "react";

import ReactEcharts from "echarts-for-react";
import { format, addDays, addMonths, isSameMonth } from "date-fns";

import axios from "@app/lib/axios";

import CommonHorizontalBarChart from "@app/components/CommonHorizontalBarChart";
import AgGridReactEx from "@app/components/AgGridReactEx";

import BooksConstants from "@app/config/BooksConstants";

import playDDStyle from "../components/style";

const appConnectChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: [{ name: "접속 수", field: "connect", stack: "base", option: { itemStyle: { color: "#5ab1ef" } } }],
    },
    stacks: [{ stack: "base", showPercent: false, showSum: false, showSumTooltip: false }],
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    showSum: true,
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};
const appNewChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: [{ name: "앱 최초 실행 수", field: "connectNew", stack: "base", type: "line", option: { smooth: false, itemStyle: { color: "#3474dc" } } }],
    },
    stacks: [{ stack: "base", showPercent: false, showSum: false, showSumTooltip: false }],
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};
const appAgeChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: playDDStyle.seriesAgeUseChart,
    },
    stacks: [
        { stack: "base0", showSum: false },
        { stack: "base1", showSum: false },
        { stack: "base2", showSum: false },
        { stack: "base3", showSum: false },
    ],
    tooltipalign: "vertical",
    tooltipFormatter: (params, chart, test) => {
        var tooltipHtml = [""];
        var tooltipTitle = "";
        var total = 0;

        params.map((e) => {
            if (e.seriesName.indexOf("Sum-") < 0) {
                total += e.value;
            }
        });
        params.map((e) => {
            if (e.seriesName.indexOf("Sum-") < 0) {
                if (!tooltipTitle) tooltipTitle += e.name + `<br/>`;

                const stackIndex = 0;
                tooltipHtml[stackIndex] += e.marker + e.seriesName + " : " + (e.value ? e.value.toLocaleString() : "-");
                tooltipHtml[stackIndex] += total > 0 ? ` (` + Math.round((e.value / total) * 100) + "%)" : "";
                tooltipHtml[stackIndex] += "<br/>";
            }
        });
        var tooltip = tooltipTitle + '<div class="text-left">';
        tooltipHtml.forEach((t, index) => {
            tooltip += t;
        });
        tooltip += `<b>합계: ${total.toLocaleString()}</b>`;
        tooltip += `</div>`;

        return tooltip;
    },
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};

const dailyPlayTimeOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "분",
        series: [
            { name: "수업시간", field: "playTimeAll", stack: "base0", option: { itemStyle: { color: "#5ab1ef" } } },
            { name: "평균 수업시간 ", field: "playTimeAvg", stack: "base1", type: "line", option: { itemStyle: { color: "#3474dc" } } },
        ],
    },
    stacks: [
        { stack: "base0", showSum: false, showSumTooltip: false },
        { stack: "base1", showSum: false, showSumTooltip: false }
    ],
    
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};

const contentPlayChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: playDDStyle.seriesContentUseChart,
    },
    stacks: [{ stack: "base", showPercent: true, showSum: false, showSumTooltip: true }],
    tooltipFormatter: (params, chart, test) => {
        var tooltipHtml = [""];
        var tooltipTitle = "";
        var total = 0;

        params.map((e) => {
            if (e.seriesName.indexOf("Sum-") < 0) {
                total += e.value;
            }
        });
        params.map((e) => {
            if (e.seriesName.indexOf("Sum-") < 0) {
                if (!tooltipTitle) tooltipTitle += e.name + `<br/>`;

                const stackIndex = 0;
                tooltipHtml[stackIndex] += e.marker + e.seriesName + " : " + (e.value ? e.value.toLocaleString() : "-");
                tooltipHtml[stackIndex] += total > 0 ? ` (` + Math.round((e.value / total) * 100) + "%)" : "";
                tooltipHtml[stackIndex] += "<br/>";
            }
        });
        var tooltip = tooltipTitle + '<div class="text-left">';
        tooltipHtml.forEach((t, index) => {
            tooltip += t;
        });
        tooltip += `<b>합계: ${total.toLocaleString()}</b>`;
        tooltip += `</div>`;

        return tooltip;
    },
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};

const appContractChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: playDDStyle.seriesContractChart,
    },
    stacks: [
        { stack: "base0", showSum: false },
        { stack: "base1", showSum: false },
    ],
    tooltipalign: "vertical",
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};

const appHomeSendChartOption = {
    xAxis: { field: "statDate" },
    yAxis: {
        name: "건",
        series: [{ name: "전송 수", field: "sendHome", stack: "base", option: { itemStyle: { color: "#5ab1ef" } } }],
    },
    stacks: [{ stack: "base", showPercent: false, showSum: false, showSumTooltip: false }],
    showLegend: true,
    legend: {
        x: "right",
        y: "top",
    },
    showSum: true,
    sort: false,
    grid: {
        top: "15%",
        left: "5%",
        right: "5%",
    },
};

const StatDevice = ({ statModel, statVersion }) => {
    const defaultColDef = {
        editable: false,
        sortable: true,
        flex: 1,
        minWidth: 60,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
    };

    const listColumnModel = [
        {
            headerName: "모델명",
            field: "model",
            minWidth: 80,
        },
        {
            headerName: "설치 수",
            field: "count",
            minWidth: 70,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "비율",
            field: "rate",
            minWidth: 70,
            sort: "desc",
            cellRenderer: (param) => {
                return param.value ? param.value.toFixed(1).toLocaleString() + "%" : "-";
            },
        },
    ];

    const listColumnVersion = [
        {
            headerName: "앱 버전",
            field: "version",
            minWidth: 80,
        },
        {
            headerName: "설치 수",
            field: "count",
            minWidth: 70,
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "비율",
            field: "rate",
            minWidth: 70,
            sort: "desc",
            cellRenderer: (param) => {
                return param.value ? param.value.toFixed(1).toLocaleString() + "%" : "-";
            },
        },
    ];

    return (
        <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="panel">
                    {statModel && statModel.length > 0 ? (
                        <AgGridReactEx height={230} defaultColDef={defaultColDef} columnDefs={listColumnModel} rowData={statModel} />
                    ) : (
                        <div style={{ textAlign: "center", height: "230px", lineHeight: "230px" }} className="align-items-center">
                            통계 자료가 없습니다.
                        </div>
                    )}
                </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="panel">
                    {statVersion && statVersion.length > 0 ? (
                        <AgGridReactEx height={230} defaultColDef={defaultColDef} columnDefs={listColumnVersion} rowData={statVersion} />
                    ) : (
                        <div style={{ textAlign: "center", height: "230px", lineHeight: "230px" }} className="align-items-center">
                            통계 자료가 없습니다.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const CategoryTable = ({ data }) => {
    const defaultColDef = {
        editable: false,
        sortable: true,
        flex: 1,
        minWidth: 90,
        maxWidth: 110,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
    };

    const listColumn = [{ headerName: " ", field: "count", minWidth: 70 }];
    const statCount = { count: "순 실행 수" };
    const statCountSum = { count: "누적 실행 수" };
    const statCategory = [];
    if (data) {
        data.map((element) => {
            listColumn.push({
                headerName: element.name,
                field: element.name,
                minWidth: 90,
            });

            if (element.name == null) {
                statCount["nuri"] = element.playCount ? element.playCount : 0;
                statCountSum["nuri"] = element.playCountSum ? element.playCountSum : 0;
            }

            statCount[element.name] = element.playCount ? element.playCount : 0;
            statCountSum[element.name] = element.playCountSum ? element.playCountSum : 0;
        });
        statCategory.push(statCount);
        statCategory.push(statCountSum);
    }
    return (
        <div>
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className="panel" style={{ width: 110 * listColumn.length, maxWidth: "100%" }}>
                    {statCategory && statCategory.length > 0 ? (
                        <AgGridReactEx height={115} defaultColDef={defaultColDef} columnDefs={listColumn} rowData={statCategory} />
                    ) : (
                        <div style={{ textAlign: "center", height: "110px", lineHeight: "110px" }} className="align-items-center">
                            통계 자료가 없습니다.
                        </div>
                    )}
                    &nbsp;
                </div>
            </div>
        </div>
    );
};

const App = forwardRef(({ statPeriod }, ref) => {
    const [stat, setStat] = useState(null);
    const [statCategory, setCategory] = useState(null);
    const [statUsage, setStatUsage] = useState(false);
    const [statPlayTime, setStatPlayTime] = useState(false);
    const [statModelHost, setStatModelHost] = useState(false);
    const [statVersionHost, setStatVersionHost] = useState(false);
    const [statModelClient, setStatModelClient] = useState(false);
    const [statVersionClient, setStatVersionClient] = useState(false);

    const [path, setPath] = useState(
        BooksConstants.HOME.EXECUTE_PATH.map((gp) => {
            return { name: gp.name, field: `cnt${gp.id}`, stack: "base" };
        })
    );

    useImperativeHandle(ref, () => ({
        getExcelData(callback) {
            var count = [[], []];
            var categoryCount = [...statCategory];
            categoryCount.map((s) => {
                count[0].push(s.playCount);
                count[1].push(s.playCountSum);
            });
            const excelData = {
                fileName: "플레이딩동_앱통계",
                sheets: [
                    {
                        name: "접속",
                        title: "접속 및 최초 실행 수 통계",
                        columnTitle: ["", "접속 수", "앱 최초 실행 수"],
                        data: statUsage ? statUsage.map((s) => [s.statDate, s.connect, s.connectNew]) : [],
                    },
                    {
                        name: "교사용 모델",
                        title: "교사용 앱 태블릿 모델 별 사용 현황",
                        columnTitle: ["모델명", "설치수", "비율"],
                        data: statModelHost ? statModelHost.map((s) => [s.model, s.count, s.rate ? s.rate.toFixed(1).toLocaleString() + "%" : "-"]) : [],
                    },
                    {
                        name: "교사용 버전",
                        title: "교사용 앱 태블릿 버전 별 사용 현황",
                        columnTitle: ["모델명", "설치수", "비율"],
                        data: statVersionHost ? statVersionHost.map((s) => [s.version, s.count, s.rate ? s.rate.toFixed(1).toLocaleString() + "%" : "-"]) : [],
                    },
                    {
                        name: "원아용 모델",
                        title: "원아용 앱 태블릿 모델 별 사용 현황",
                        columnTitle: ["앱", "앱 버전", "사용자 수"],
                        data: statModelClient ? statModelClient.map((s) => [s.model, s.count, s.rate ? s.rate.toFixed(1).toLocaleString() + "%" : "-"]) : [],
                    },
                    {
                        name: "원아용 버전",
                        title: "원아용 앱 태블릿 버전 별 사용 현황",
                        columnTitle: ["앱", "앱 버전", "사용자 수"],
                        data: statVersionClient ? statVersionClient.map((s) => [s.version, s.count, s.rate ? s.rate.toFixed(1).toLocaleString() + "%" : "-"]) : [],
                    },
                    {
                        name: "연령",
                        title: "연령별 사용량 통계",
                        columnTitle: ["", "만3세", "만4세", "만5세", "혼합"],
                        data: statUsage ? statUsage.map((s) => [s.statDate, s.age1, s.age2, s.age3, s.age123]) : [],
                    },
                    {
                        name: "일별 수업 시간(분)",
                        title: "일별 수업 시간(분)",
                        columnTitle: ["", "수업시간", "평균 수업시간"],
                        data: statPlayTime ? statPlayTime.map((s) => [s.statDate, s.playTimeAll, s.playTimeAvg]) : [],
                    },
                    {
                        name: "메뉴 별 사용 현황(건)",
                        title: "메뉴 별 사용 현황(건)",
                        columnTitle: ["", "딩동수업", "딩동AR", "협동그림"],
                        data: statUsage ? statUsage.map((s) => [s.statDate, s.playNormal, s.playAR, s.playCollabo]) : [],
                    },
                    {
                        name: "콘텐츠 카테고리별 콘텐츠 실행 수",
                        title: "콘텐츠 카테고리별 콘텐츠 실행 수",
                        columnTitle: statCategory && statCategory.map((s) => (s.name == null ? "누리과정" : s.name)),
                        data: [count[0], count[1]],
                    },
                    {
                        name: "원아 등록 현황",
                        title: "원아 등록 현황",
                        columnTitle: ["", "계약 원아 수", "등록 원아 수"],
                        data: statUsage ? statUsage.map((s) => [s.statDate, s.childContract, s.childJoin]) : [],
                    },
                    {
                        name: "포트폴리오 전송 현황(건)",
                        title: "포트폴리오 전송 현황(건)",
                        columnTitle: ["", "전송 수"],
                        data: statUsage ? statUsage.map((s) => [s.statDate, s.sendHome]) : [],
                    },
                ],
            };
            callback(null, excelData);
        },
    }));

    const getStat = useCallback(() => {
        axios({
            method: "POST",
            url: `/api/playdd/stat/hq/app`,
            data: {
                startDate: statPeriod.startDate,
                endDate: statPeriod.endDate,
                limit: 5,
                periodType: statPeriod.type,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const stat = result.data.data;
                    let statUsage = [];
                    let statVersionHost = null;
                    let statModelHost = null;
                    let statVersionClient = null;
                    let statModelClient = null;
                    let statPathTemp = [];
                    let statPlayTime = [];

                    let pathNullExist = false;
                    if (stat.path && stat.path.length > 0) {
                        stat.path.forEach((s) => {
                            const group = FlyEngConstants.HOME.EXECUTE_PATH.find((ep) => s.path.indexOf(ep.groupPath) === 0);
                            if (group) {
                                const cntPath = `cnt${group.id}`;
                                const path = statPathTemp.find((sp) => sp.statDate == s.statDate);
                                if (path) {
                                    path[cntPath] = (path[cntPath] || 0) + s.cnt;
                                } else {
                                    const pathNew = { statDate: s.statDate };
                                    pathNew[cntPath] = s.cnt;
                                    statPathTemp.push(pathNew);
                                }
                                if (group.id < 0) {
                                    pathNullExist = true;
                                }
                            }
                        });
                    }
                    if (pathNullExist) {
                        const pathNew = path.shift();
                        setPath(pathNew);
                    }

                    let start = new Date(statPeriod.startDate);
                    let day = new Date(statPeriod.startDate);
                    stat.usage.forEach(
                        (s) => (
                            (s.playTimeAll = Math.floor(((s.playtimeNormal + s.playtimeAR + s.playtimeCollabo) / 60) * 10) / 10),
                            (s.playTimeAvg = Math.floor((s.playTimeAll / (s.playNormal + s.playAR + s.playCollabo)) * 10) / 10)
                        )
                    );
                    for (let i = 0; i < 99; i++) {
                        const statDate = format(day, statPeriod.type === "year" ? "yyyy-MM" : "yyyy-MM-dd");
                        const statDateStr = format(day, statPeriod.type === "year" ? "yyyy-MM" : "MM-dd");

                        const sUsage = stat.usage.find((s) => s.statDate === statDate);
                        const sPlayTime = stat.usage.find((s) => s.statDate === statDate);
                        statPlayTime.push({ ...sPlayTime, statDate: statDateStr });
                        statUsage.push({ ...sUsage, statDate: statDateStr });
                        if (statPeriod.type === "week") {
                            day = addDays(day, 1);
                            if (i >= 6) break;
                        } else if (statPeriod.type === "month") {
                            day = addDays(day, 1);
                            if (!isSameMonth(day, start)) break;
                        } else {
                            // year
                            day = addMonths(day, 1);
                            if (i > 11) break;
                        }
                    }

                    statVersionHost = stat.version_host;
                    statModelHost = stat.model_host;
                    statVersionClient = stat.version_client;
                    statModelClient = stat.model_client;

                    if (statVersionHost.length > 0) {
                        const total = statVersionHost.reduce((ac, s) => ac + (s.count ? s.count : 0), 0);
                        statVersionHost.forEach((s) => (s.rate = (s.count / total) * 100));
                    }
                    if (statModelHost.length > 0) {
                        const total = statModelHost.reduce((ac, s) => ac + (s.count ? s.count : 0), 0);
                        statModelHost.forEach((s) => (s.rate = (s.count / total) * 100));
                    }
                    if (statVersionClient.length > 0) {
                        const total = statVersionClient.reduce((ac, s) => ac + (s.count ? s.count : 0), 0);
                        statVersionClient.forEach((s) => (s.rate = (s.count / total) * 100));
                    }
                    if (statModelClient.length > 0) {
                        const total = statModelClient.reduce((ac, s) => ac + (s.count ? s.count : 0), 0);
                        statModelClient.forEach((s) => (s.rate = (s.count / total) * 100));
                    }

                    stat.category.map((c) => {
                        var findCategory = stat.category_count.find((e) => e.categoryId == c.id);
                        if (c.id == 11) findCategory = stat.category_count.find((e) => e.categoryId == null)
                        if (findCategory != null) {
                            c.playCount = findCategory.playCount;
                            c.playCountSum = findCategory.playCountSum;
                        } else {
                            c.playCount = 0;
                            c.playCountSum = 0;
                        }
                    });

                    setStat(stat);
                    setCategory(stat.category);
                    setStatUsage(statUsage);
                    setStatModelHost(statModelHost);
                    setStatVersionHost(statVersionHost);
                    setStatModelClient(statModelClient);
                    setStatVersionClient(statVersionClient);
                    setStatPlayTime(statPlayTime);
                } else {
                    alert(result.data && result.data.msg ? result.data.msg : "통계 정보를 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    }, [statPeriod]);
    useEffect(() => {
        getStat();
        return () => {};
    }, [getStat]);

    return (
        <div className="w-100">
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">접속 수</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statUsage} chartOption={appConnectChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">앱 최초 실행 수</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statUsage} chartOption={appNewChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">교사용 앱 전자칠판 모델 별 사용 현황</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <StatDevice statModel={statModelHost} statVersion={statVersionHost} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">원아용 앱 태블릿 모델 별 사용 현황</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <StatDevice statModel={statModelClient} statVersion={statVersionClient} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">연령별 사용량</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statUsage} chartOption={appAgeChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">일별 수업 시간(분)</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statPlayTime} chartOption={dailyPlayTimeOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">메뉴별 사용 현황(건)</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statUsage} chartOption={contentPlayChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">카테고리별 콘텐츠 실행 수</h4>
                        </div>
                        <CategoryTable data={statCategory} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">원아 등록 현황</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statUsage} chartOption={appContractChartOption} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
                            <h4 className="card-header-title">포트폴리오 전송 현황(건)</h4>
                        </div>
                        <div className="card-body" style={{ height: "300px" }}>
                            <CommonHorizontalBarChart chartData={statUsage} chartOption={appHomeSendChartOption} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default App;
